import type {
  NormalizedRelease,
  ReleaseApiResponse,
  ReleaseItem,
  ReleasePlatform,
} from "../../types/releaseData";

export function filterReleaseItems(
  items: ReleaseItem[],
  platformTags: string[] = ["All", "newUI_Web"],
): ReleaseItem[] {
  return items.filter(
    (item) =>
      Array.isArray(item.platform) &&
      item.platform.some((platform) => platformTags.includes(platform)),
  );
}

export function normalizeReleaseData(
  raw: ReleaseApiResponse | null | undefined,
  platformTag: ReleasePlatform = "newUI_Web",
): NormalizedRelease[] {
  const results = Array.isArray(raw?.results)
    ? raw.results
    : Array.isArray(raw?.data?.results)
      ? raw.data.results
      : [];

  if (results.length === 0) {
    return [];
  }

  const platformTags = ["All", platformTag];
  if (platformTag === "newUI_Android" || platformTag === "newUI_iOS") {
    platformTags.push("newUI_app");
  }

  return results
    .map((release) => {
      const filteredItems = filterReleaseItems(release.items || [], platformTags);

      return {
        version: release.version,
        releaseDate: release.releaseDate,
        newItems: filteredItems.filter((item) => item.category === "New"),
        improvedItems: filteredItems.filter((item) => item.category === "Improved"),
        fixedItems: filteredItems.filter((item) => item.category === "Fixed"),
        totalUpdatesCount: filteredItems.length,
      };
    })
    .filter((release) => release.totalUpdatesCount > 0)
    .sort((a, b) => {
      const dateA = new Date(a.releaseDate).getTime();
      const dateB = new Date(b.releaseDate).getTime();
      if (!isNaN(dateA) && !isNaN(dateB) && dateA !== dateB) {
        return dateB - dateA;
      }
      return (b.version || "").localeCompare(a.version || "", undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });
}
